<div class="container">
  <sca-module-title class="title-test">
    <h1>Common Playground</h1>
    <span scaModuleTitlePost>Testing exhaustivo de @argo/common - HttpContext Tokens & Utilities</span>
  </sca-module-title>
  
  <!-- SECCIÓN 1: CommonPhase Enum -->
  <section class="card">
    <h2>CommonPhase Enum</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      CommonPhase define 4 estados del ciclo de vida que utilizan múltiples stores (TracesStore, SessionStore, SecurityStore). Este enum proporciona consistencia en la gestión de estados IDLE, LOADING, LOADED y ERROR a través de toda la arquitectura Argo.
    </sca-alert>
    
    <div class="status-grid">
      <sca-card-workshop>
        <header scaCardWorkshopHeader>
          <sca-badge variant="default" [rounded]="false">Inicial</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Estado inactivo</p>
        <p scaCardWorkshopAddress>IDLE ({{ phases.IDLE }})</p>
      </sca-card-workshop>

      <sca-card-workshop>
        <header scaCardWorkshopHeader>
          <sca-badge variant="warning" [rounded]="false">En curso</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Cargando datos</p>
        <p scaCardWorkshopAddress>LOADING ({{ phases.LOADING }})</p>
      </sca-card-workshop>

      <sca-card-workshop>
        <header scaCardWorkshopHeader>
          <sca-badge variant="success" [rounded]="false">Completado</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Carga exitosa</p>
        <p scaCardWorkshopAddress>LOADED ({{ phases.LOADED }})</p>
      </sca-card-workshop>

      <sca-card-workshop>
        <header scaCardWorkshopHeader>
          <sca-badge variant="error" [rounded]="false">Error</sca-badge>
        </header>
        <p scaCardWorkshopTitle>Error en proceso</p>
        <p scaCardWorkshopAddress>ERROR ({{ phases.ERROR }})</p>
      </sca-card-workshop>
    </div>
  </section>

  <!-- SECCIÓN 2: HttpContext Tokens -->
  <section class="card">
    <h2>HttpContext Tokens</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Tokens para controlar el comportamiento de los interceptores HTTP
    </sca-alert>

    <div class="status-grid">
      <sca-card-workshop>
        <span scaCardWorkshopBadge>
          <sca-badge variant="success">Token Activo</sca-badge>
        </span>
        <h3 scaCardWorkshopTitle>FORCE_INTERNAL</h3>
        <p scaCardWorkshopDescription>
          Fuerza autenticación en APIs externas que requieren autorización
        </p>
      </sca-card-workshop>

      <sca-card-workshop>
        <span scaCardWorkshopBadge>
          <sca-badge variant="success">Token Activo</sca-badge>
        </span>
        <h3 scaCardWorkshopTitle>SKIP_AUTH</h3>
        <p scaCardWorkshopDescription>
          Omite autenticación para endpoints públicos sin credenciales
        </p>
      </sca-card-workshop>

      <sca-card-workshop>
        <span scaCardWorkshopBadge>
          <sca-badge variant="success">Token Activo</sca-badge>
        </span>
        <h3 scaCardWorkshopTitle>SKIP_TRACES</h3>
        <p scaCardWorkshopDescription>
          Previene trace-of-trace loops en TracesStore
        </p>
      </sca-card-workshop>

      <sca-card-workshop>
        <span scaCardWorkshopBadge>
          <sca-badge variant="success">Token Activo</sca-badge>
        </span>
        <h3 scaCardWorkshopTitle>SKIP_MULTILANGUAGE</h3>
        <p scaCardWorkshopDescription>
          Omite interceptor de traducción para assets i18n
        </p>
      </sca-card-workshop>
    </div>

    <code class="code-block">const context = new HttpContext()
  .set(FORCE_INTERNAL, true)
  .set(SKIP_TRACES, true);

this.http.post(url, body, {{ '{' }} context {{ '}' }} );</code>
  </section>

  <!-- SECCIÓN 3: Testing de Tokens -->
  <section class="card">
    <h2>Testing de Tokens</h2>
    
    <sca-alert variant="info" style="margin-bottom: 1.5rem;">
      <sca-icon icon="info" size="24px" [weight]="300" left />
      Prueba los diferentes tokens de HttpContext
    </sca-alert>

    <div class="button-grid">
      <button sca-button variant="primary" size="medium" (click)="testForceInternal()">
        <sca-icon icon="lock" size="20"></sca-icon>
        Test FORCE_INTERNAL
      </button>
      <button sca-button variant="border" size="medium" (click)="testSkipAuth()">
        <sca-icon icon="public" size="20"></sca-icon>
        Test SKIP_AUTH
      </button>
      <button sca-button variant="primary" size="medium" (click)="testSkipTraces()">
        <sca-icon icon="timeline" size="20"></sca-icon>
        Test SKIP_TRACES
      </button>
      <button sca-button variant="border" size="medium" (click)="testSkipMultilanguage()">
        <sca-icon icon="translate" size="20"></sca-icon>
        Test SKIP_MULTILANGUAGE
      </button>
    </div>
  </section>

  
</div>
